<template>
<div>
  <el-row>
    <el-col :span="17">
      <!-- 面包屑导航区域-->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
        <el-breadcrumb-item>Setup</el-breadcrumb-item>
        <el-breadcrumb-item>System Role</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
      Updating Time: {{ this.updateTime }}
      </el-col> -->
  </el-row>
  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="Role Name:">
        <el-input v-model="formInline.roleName" placeholder="Role Name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">Search</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="customerDialogOpen('add')">Add</el-button>
      </el-form-item>
    </el-form>

    <!-- CRProject 列表区域 -->
    <el-table :data="roleList" border stripe style="width: 100%">
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column
        prop="roleCode"
        label="Role Code"         sortable
        width="150">
      </el-table-column>
      <el-table-column
        prop="roleName"      sortable
        label="Role Name"
        width="150">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="Create Time"
        width="">
      </el-table-column>

      <el-table-column label="Operation" width="350">
        <template slot-scope="index">
          <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
          <el-button type="info" plain size="mini" @click="getUsers(index)">Users</el-button>
          <el-button type="info" plain size="mini" @click="getPermissions(index)">Permissions</el-button>
          <el-button type="info" plain size="mini" @click="edit(index)">Edit</el-button>
<!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页区域-->
    <!--<el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="formInline.page"
      :page-sizes="[10, 20, 30, 50, 100, total]"
      :page-size="formInline.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>-->
  </el-card>
  <el-dialog title="Role"
             width="50%" :visible.sync="dialogFormVisible" >
    <el-form :model="role" label-width="200px" ref="userOpenform">
      <el-form-item required label="Role Code:" prop="role.roleCode">
        <el-input v-model="role.roleCode" style="width: 300px"></el-input>
      </el-form-item>
      <el-form-item required label="Role Name:" prop="role.roleName">
        <el-input v-model="role.roleName" style="width: 300px"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">Cancel</el-button>
      <el-button type="primary" @click="customerDialogSave('userOpenform')">Save</el-button>
    </div>
  </el-dialog>
  <el-dialog :title=dialog
             width="50%" :visible.sync="dialogFormVisible2" >
    <div v-if="users.length>0">
      <p> Role Name: {{indexRole.roleName}}</p>
      <h5 v-for="item in this.users"
         :key="item"
         :label="item"
         :value="item"> User: {{ item.userId }}</h5>
    </div>
    <div v-if="permissions.length>0">
      <p> Role Name: {{indexRole.roleName}}</p>
      <h5 v-for="item in this.permissions"
          :key="item"
          :label="item"
          :value="item"> Permission Name: {{ item.name }} Level: {{ item.level }} Menu Type: {{ item.menuType }} Hidden: {{ item.hidden }}</h5>
    </div>
  </el-dialog>

</div>
</template>

<script>
export default {
  name: 'SystemRole',
  data () {
    return {
      indexRole: {},
      users: [],
      permissions: [],
      role: {},
      roleList: [],
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialog: '',
      formInline: {
        roleName: '',
        page: 1,
        rows: 100
      }
    }
  },
  created () {
    // this.userName = window.sessionStorage.getItem('username')
    // this.loginname = window.sessionStorage.getItem('loginname')
    // this.formInline.token = window.sessionStorage.getItem('token')
    // this.brandParam.userName = this.userName
    // this.brandParam.userType = window.sessionStorage.getItem('userType')
    // this.getOrgList()
    this.getRoleList()
  },
  methods: {
    async customerDialogSave () {
      if (!this.role.roleCode) {
        this.$message({
          message: 'Role Code is mandatory ',
          type: 'warning'
        })
        return
      }
      if (!this.role.roleName) {
        this.$message({
          message: 'Role Name is mandatory ',
          type: 'warning'
        })
        return
      }
      if (this.dialog === 'add') {
        const { data: res } = await this.$http.post('/systemRole/addRole', this.role)
        if (res === 200) {
          this.dialogFormVisible = false
          this.getRoleList()
          this.$message({
            message: 'Added or updated successfully',
            type: 'success'
          })
        }
      } else if (this.dialog === 'edit') {
        const { data: res } = await this.$http.post('/systemRole/updateRole', this.role)
        if (res === 200) {
          this.dialogFormVisible = false
          this.getRoleList()
          this.$message({
            message: 'Added or updated successfully',
            type: 'success'
          })
        }
      } else {
        console.log(11)
      }
    },
    async getUsers (x) {
      this.users = []
      this.permissions = []
      this.dialogFormVisible2 = true
      this.dialog = 'Users'
      this.indexRole = x.row
      const { data: res } = await this.$http.get('/systemRole/getUsers' + '?id=' + x.row.id)
      this.users = res
    },
    async getPermissions (x) {
      this.users = []
      this.permissions = []
      this.dialogFormVisible2 = true
      this.dialog = 'Permissions'
      this.indexRole = x.row
      const { data: res } = await this.$http.get('/systemRole/getPermissions' + '?id=' + x.row.id)
      this.permissions = res
    },
    edit (x) {
      console.log(x.row)
      this.dialogFormVisible = true
      this.dialog = 'edit'
      this.role = x.row
    },
    onSubmit () {
      console.log('submit!')
      this.getRoleList()
    },
    customerDialogOpen (x) {
      console.log('submit!')
      this.dialogFormVisible = true
      this.dialog = 'add'
      this.role = {}
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      // this.getUsers()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      // this.getUsers()
    },
    // async getUsers () {
    //   const { data: res } = await this.$http.get('/userManagement/userList', { params: this.formInline })
    //   this.userList = res.rows
    //   this.total = res.total
    // },
    async getRoleList () {
      const { data: res } = await this.$http.get('/systemRole/getUserRole', { params: this.formInline })
      this.roleList = res
      this.total = res.total
    }
  }
}
</script>

<style scoped>

</style>
